export default __webpack_public_path__ + "static/media/travel-medicine-4.62c8c654.svg";